import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ServiceDataList } from 'src/app/components/massive/models/serviceDataList.model';
import { Service } from 'src/app/components/massive/models/services.model';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { TableColumn } from 'src/app/components/shared/types/tableColumn.type';
import { MassiveServiceFlags } from '../../massive-services.flags';
import { Filters } from 'src/app/components/shared/types/filters.type';
import { DeliveriesFilters } from 'src/app/components/massive/models/deliveriesFilters.model';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { TableEditingActionsTypes } from 'src/app/components/shared/sharedModules/designSystem/models/tableEditingActionsTypes.enum';
import { TableOption } from 'src/app/components/massive/models/tableOption.interface';
import { DeliveriesFilterColumns } from 'src/app/components/massive/models/deliveriesFilterColumns.enum';
import { UntypedFormGroup } from '@angular/forms';
import { FilterField } from 'src/app/components/shared/types/filterField.type';
import { ItemNumberToFilterShared } from 'src/app/components/shared/models/interface/itemNumberToFilter.interface';
import { FiltersToolbarActionsTypes } from 'src/app/components/shared/sharedModules/designSystem/models/filterToolbarActionsTypes.enum';
import { DeliveriesFiltersToolbarComponent } from '../deliveries-filters-toolbar/deliveries-filters-toolbar.component';
import { MapElementShared } from 'src/app/components/shared/models/interface/mapElement.interface';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';

@Component({
  selector: 'app-massive-deliveries-table',
  templateUrl: './deliveries-table.component.html',
  styleUrls: ['./deliveries-table.component.sass'],
})
export class DeliveriesTableComponent extends MuComponent implements AfterViewInit {
  private _dataList: ServiceDataList;
  @Input() set dataList(value: ServiceDataList) {
    this._dataList = value;
    if (this.dataList && this.selectedServices) {
      this.isCheckAll = false;
      this.isCheckAll = this.areAllselected(this.selectedServices, this.dataList.values, 'serviceId');
    }
  }
  get dataList(): ServiceDataList {
    return this._dataList;
  }
  @Input() flags: Flags<MassiveServiceFlags>;
  @Input() filters: Filters<DeliveriesFilters>;
  @Input() filterFields: FilterField<DeliveriesFilters>[];
  @Input() tableListColumns: TableColumn<Service, DeliveriesFilters>[];
  @Input() tableOptionListEdition: TableOption[] = [];
  @Input() tableOptionListSelection: TableOption[] = [];
  @Input() actionsEdition: Actions<TableEditingActionsTypes, Service>;
  @Input() actionsSelection: Actions<TableEditingActionsTypes, Service>;
  @Input() formData: UntypedFormGroup;
  @Input() localityList: ItemNumberToFilterShared[];
  @Input() weightList: ItemNumberToFilterShared[];
  @Input() breadCrumbItems: string[];
  @Input() markers: MapElementShared[];
  @Output() rowSelectionEvent = new EventEmitter<Service[]>();

  isCheckAll = false;
  filterColumns = DeliveriesFilterColumns;
  selectedServices: Service[] = [];
  massiveServiceFlags = MassiveServiceFlags;
  isViewChecked = false;

  @ViewChild('filterToolbarService') filterToolbarService: DeliveriesFiltersToolbarComponent;

  /**
   * disable delete filters
   */
  disableDeleteFilter = false;

  /** The filter toolbar filters */
  filterToolbarActions = new Actions<FiltersToolbarActionsTypes, DeliveriesFilters>();

  muOnDestroy(): void {
    /** */
  }

  muOnInit(): void {
    /** */
  }

  /**
   * select all Services and emit
   */
  checkAll(): void {
    if (!this.isCheckAll) {
      this.selectedServices = this.deleteSelectedServices(this.selectedServices, this.dataList.values, 'serviceId');
      this.selectedServices = this.deleteRepeatedItems(this.selectedServices, 'orderId');
    } else {
      this.selectedServices = this.selectedServices.concat(this.dataList.values);
      this.selectedServices = this.deleteRepeatedItems(this.selectedServices, 'orderId');
    }
    this.rowSelectionEvent.emit(this.selectedServices);
  }

  /**
   * @description delete the services of the actual page of the table
   * @param selectedServices
   * @param actualDataList
   * @param key
   * @returns new array with just the selected services
   */
  deleteSelectedServices(selectedServices: any[], actualDataList: any[], key: string): any[] {
    let indexToRemove;
    actualDataList.map(itemData => {
      indexToRemove = selectedServices.map(item => item[key]).indexOf(itemData[key]);
      if (indexToRemove !== -1) {
        selectedServices.splice(indexToRemove, 1);
      }
    });
    return selectedServices;
  }

  /**
   * @description true or false if the arrayData contains the values
   * @param arrayData
   * @param values
   * @param key
   * @returns true or false if the arrayData contains the values
   */
  areAllselected(arrayData: any[], values, key: string) {
    const continent = this.getvaluesByKey(arrayData, key);
    const content = this.getvaluesByKey(values, key);
    const founded = continent.filter(item => content.includes(item));
    if (founded.length === content.length) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * @description returns new array with unique items
   * @param items
   * @returns new array with unique items
   */
  deleteRepeatedItems(items: any[], key: string): any[] {
    let keys = this.getvaluesByKey(items, key);

    const setOfKeys = new Set(keys);
    keys = [...setOfKeys];

    const uniqueArray = [];

    keys.map(index => {
      uniqueArray.push(
        items.find(item => {
          return item[key] === index;
        })
      );
    });

    return uniqueArray;
  }

  /**
   * @description returns the values of the array by key
   * @param array
   * @param key
   * @returns values acording to the key
   */
  getvaluesByKey(array: any[], key: string) {
    return array.map(item => {
      return item[key];
    });
  }

  /**
   * update actual Services selection and emit
   */
  updateSelectedServices(): void {
    this.isCheckAll = this.areAllselected(this.selectedServices, this.dataList.values, 'serviceId');
    this.rowSelectionEvent.emit(this.selectedServices);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isViewChecked = true;
    }, 2000);
  }
}
